import { RootState } from '../reducers';

const selectFilterModal = (state: RootState) => state.modals.filterModal;

export { selectFilterModal };
